import {
  resetSelectedProductStock,
  setSelectedProductStock,
} from './../actions/product-stock.actions';
import { Injectable, inject } from '@angular/core';
import { WindowRef } from '@boels/helpers';
import {
  BoelsPointOfServiceStock,
  GeoPoint,
  SearchConfig,
} from '@boels/models';
import { Action, select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { findProductStock } from '../actions/product-stock.actions';
import { ProductStockState } from '../reducers/product-stock.reducer';
import {
  selectProductStockState,
  selectSelectedProductStock,
  selectStockStores,
} from '../selectors/product-stock.selectors';

@Injectable()
export class ProductStockFacade {
  protected store = inject(Store);
  protected winRef = inject(WindowRef);

  private geolocationWatchId: number | null = null;

  getProductStockState(): Observable<ProductStockState> {
    return this.store.pipe(select(selectProductStockState));
  }

  getProductStockStores(): Observable<BoelsPointOfServiceStock[]> {
    return this.store.pipe(select(selectStockStores));
  }

  getSelectedProductStockStore(): Observable<
    { query: string; store: BoelsPointOfServiceStock } | undefined
  > {
    return this.store.pipe(select(selectSelectedProductStock));
  }

  setSelectedProductStock(state?: {
    query: string;
    selectedProductStock: BoelsPointOfServiceStock;
  }): void {
    if (!state) return this.store.dispatch(resetSelectedProductStock());
    return this.store.dispatch(setSelectedProductStock(state));
  }

  loadClosestStores(
    productCodes: string[],
    queryText: string,
    searchConfig: SearchConfig,
    useMyLocation?: boolean,
  ): void {
    if (useMyLocation && this.winRef.nativeWindow) {
      this.clearWatchGeolocation();
      this.geolocationWatchId =
        this.winRef.nativeWindow.navigator.geolocation.watchPosition((pos) => {
          const position: GeoPoint = {
            longitude: pos.coords.longitude,
            latitude: pos.coords.latitude,
          };

          this.clearWatchGeolocation(
            findProductStock({
              productCodes,
              queryText,
              searchConfig,
              longitudeLatitude: position,
            }),
          );
        });
    } else {
      this.clearWatchGeolocation(
        findProductStock({
          productCodes,
          queryText,
          searchConfig,
        }),
      );
    }
  }

  private clearWatchGeolocation(callbackAction?: Action): void {
    if (this.geolocationWatchId !== null) {
      this.winRef?.nativeWindow?.navigator.geolocation.clearWatch(
        this.geolocationWatchId,
      );
      this.geolocationWatchId = null;
    }
    if (callbackAction) {
      this.store.dispatch(callbackAction);
    }
  }
}
